import { weights, colors } from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem } from 'polished';

interface StyledTitleProps {
  $isGroup?: boolean;
}
export const StyledRequests = styled('div')<StyledTitleProps>(
  ({ $isGroup }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: rem(5),
    marginTop: rem(10),
    ...($isGroup && {
      gap: rem(0),
    }),
  }),
);

export const StyledRequestsHead = styled('div')<StyledTitleProps>(
  ({ $isGroup }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    ...($isGroup && {
      background: colors.grayLight1,
      padding: `${rem(8)} ${rem(12)}`,
      borderRadius: rem(12),
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }),
  }),
);

export const StyledTitle = styled('span')<StyledTitleProps>(({ $isGroup }) => ({
  fontSize: rem(15),
  fontWeight: weights.semiBold,
  wordBreak: 'break-word',
  whiteSpace: 'pre-line',
  ...($isGroup && {
    fontWeight: weights.semiBold,
    fontSize: rem(16),
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    display: 'block',
    textAlign: 'left',
  }),
}));

export const StyledButtonGroup = styled('div')({
  display: 'flex',
  gap: rem(10),
});

export const StyledContainer = styled('div')<{ $opaque: boolean }>(
  ({ $opaque }) => ({
    ...($opaque && {
      opacity: 0.5,
      pointerEvents: 'none',
      userSelect: 'none',
    }),
  }),
);

export const StyledCreateContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  gap: rem(10),
  marginTop: rem(20),
});

export const Heading = styled('div')({
  fontSize: rem(16),
  fontWeight: weights.semiBold,
  marginBottom: rem(10),
});
